export default __webpack_public_path__ + "static/media/manager-qrcode.737c66b1.png";